import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import theme from '../../../theme/theme';

export function EmployeeCreationPage() {
  const { t } = useTranslation('common');

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" component="h1" sx={{ mb: 2 }} color={theme.palette.text.secondary}>
        {t('employeeCreation.title')}
      </Typography>
      <Typography variant="body1" color={theme.palette.text.secondary}>
        {t('employeeCreation.description')}
      </Typography>
    </Box>
  );
}
